<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="10" md="11" sm="12">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          width="300"
          contain
        />
      </v-col>
    </v-toolbar>

    <!-- # -->
    <login-report-table />
    <!-- # -->
  </div>
</template>
<script>
const loginReportTable = () =>
  import("@/components/Tables/LoginReportTable.vue");
export default {
  name: "loginReport",
  components: {
    loginReportTable,
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({ name: "Pricing" });
    } else {
      next();
    }
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
